
import { useState, useRef } from "preact/hooks";
import { render, createContext } from "preact";
import { Modal, Button } from "react-bootstrap";

export const ConfirmationModalContext = createContext();

const ConfirmationModalProvider = ({ children }) => {
    const [show, setShow] = useState(false);
    const [content, setContent] = useState({});
    const resolver = useRef();


    const showConfirmation = (title, message, options = { confirmOnly: false, confirmLabel: "Confirmer", cancelLabel: "Annuler" }) => {
        setContent({ title, message, ...options });
        setShow(true);

        return new Promise(function (resolve) {
            resolver.current = resolve;
        });
    }

    const handleOK = () => {
        resolver.current && resolver.current(true);
        setShow(false);
    }

    const handleCancel = () => {
        resolver.current && resolver.current(false);
        setShow(false);
    }

    return (
        <ConfirmationModalContext.Provider value={{ showConfirmation }}>
            {children}

            <Modal show={show} onHide={() => setShow(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title className="fw-bold">{content.title}</Modal.Title>
                </Modal.Header>

                <Modal.Body className="py-4">
                    {content.message}
                </Modal.Body>

                <Modal.Footer className="border-0">
                    {!content.confirmOnly && (
                        <Button variant="secondary" className="btn-hover-primary" onClick={handleCancel}>
                            {content.cancelLabel || "Annuler"}
                        </Button>
                    )}

                    <Button variant="primary" onClick={handleOK}>
                        {content.confirmLabel || (content.confirmOnly ? "OK" : "Confirmer")}
                    </Button>
                </Modal.Footer>
            </Modal>
        </ConfirmationModalContext.Provider>
    );
};

export default ConfirmationModalProvider;
